/*
 * Responsively Lazy
 * http://ivopetkov.com/b/lazy-load-responsive-images/
 * Copyright 2015-2017, Ivo Petkov
 * Free to use under the MIT license.
*/
var responsivelyLazy = typeof responsivelyLazy !== 'undefined' ? responsivelyLazy : (function() {
  let r = !1; let t = !1; var l = null; var p = null; const m = typeof IntersectionObserver !== 'undefined'; let q = !1; const u = []; const v = function(a) {
    if (l === null) {
      return !1;
    }

    var b = a.getBoundingClientRect();

    a = b.top;

    const c = b.left; const d = b.width; var b = b.height;

    return a < p && a + b > 0 && c < l && c + d > 0;
  }; var w = function(a, b) {
    for (var c = a.length, d = b; d < c; d++) {
      let h = !1; const f = a[d]; const e = document.createElement('script'); let g = f.getAttribute('type');

      g !== null && e.setAttribute('type', g); g = f.getAttribute('src');

      g !== null
&& (e.setAttribute('src', g), (typeof f.async === 'undefined' || !1 === f.async) && d + 1 < c && (h = !0, e.addEventListener('load', function() {
  w(a, d + 1);
}))); e.innerHTML = f.innerHTML; f.parentNode.insertBefore(e, f); f.parentNode.removeChild(f);

      if (h) {
        break;
      }
    }
  }; const x = function(a, b) {
    var c = b.getAttribute('data-srcset');

    if (c !== null) {
      if (c = c.trim(), c.length > 0) {
        var c = c.split(','); var d = []; var h = c.length;

        for (var f = 0; f < h; f++) {
          var e = c[f].trim();

          if (e.length !== 0) {
            let g = e.lastIndexOf(' ');

            if (g === -1) {
              var k = e;

              e = 999998;
            } else {
              k = e.substr(0, g), e = parseInt(e.substr(g
+ 1, e.length - g - 2), 10);
            }g = !1; k.indexOf('.webp', k.length - 5) !== -1 ? r && (g = !0) : g = !0; g && d.push([k, e]);
          }
        }

        d.sort(function(a, b) {
          if (a[1] < b[1]) {
            return -1;
          }

          if (a[1] > b[1]) {
            return 1;
          }

          if (a[1] === b[1]) {
            if (b[0].indexOf('.webp', b[0].length - 5) !== -1) {
              return 1;
            }

            if (a[0].indexOf('.webp', a[0].length - 5) !== -1) {
              return -1;
            }
          }

          return 0;
        }); c = d;
      } else {
        c = [];
      }
    } else {
      c = [];
    }k = a.offsetWidth * (typeof window.devicePixelRatio !== 'undefined' ? window.devicePixelRatio : 1); d = null; h = c.length;

    for (f = 0; f < h; f++) {
      if (e = c[f], e[1] >= k) {
        d = e; break;
      }
    }

    d === null && (d = [b.getAttribute('src'),
      999999]); typeof a.responsivelyLazyLastSetOption === 'undefined' && (a.responsivelyLazyLastSetOption = ['', 0]);

    a.responsivelyLazyLastSetOption[1] < d[1] && (a.responsivelyLazyLastSetOption = d, h = d[0], typeof a.responsivelyLazyEventsAttached === 'undefined' && (a.responsivelyLazyEventsAttached = !0, b.addEventListener('load', function() {
      const b = a.getAttribute('data-onlazyload');

      b !== null && (new Function(b)).bind(a)();
    }, !1), b.addEventListener('error', function() {
      a.responsivelyLazyLastSetOption = ['', 0];
    }, !1)), h === b.getAttribute('src')
      ? b.removeAttribute('srcset') : b.setAttribute('srcset', h));
  }; const y = function(a) {
    if (u.indexOf(a) === -1 && v(a)) {
      let b = a.getAttribute('data-lazycontent');

      b !== null ? (u.push(a), q = !0, a.innerHTML = b, a = a.querySelectorAll('script'), a.length > 0 && w(a, 0), q = !1) : t && (a.tagName.toLowerCase() === 'img' ? x(a, a) : (b = a.querySelector('img'), b !== null && x(a, b)));
    }
  }; const z = function() {
    for (let a = document.querySelectorAll('.responsively-lazy'), b = a.length, c = 0; c < b; c++) {
      y(a[c]);
    }
  };

  if (typeof window.addEventListener !== 'undefined' && typeof document.querySelectorAll !== 'undefined') {
    var l
= window.innerWidth; var p = window.innerHeight; const n = new Image();

    n.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEADMDOJaQAA3AA/uuuAAA=';

    n.onload = n.onerror = function() {
      r = n.width === 2; t = 'srcset' in document.createElement('img');

      const a = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(a) {
        window.setTimeout(a, 1E3 / 60);
      }; let b = !0; var c = function() {
        b && (b = !1, z()); a.call(null, c);
      };

      c();

      if (m) {
        var d = function() {
          for (let a = document.querySelectorAll('.responsively-lazy'),
            b = a.length, c = 0; c < b; c++) {
            const e = a[c];

            typeof e.responsivelyLazyObserverAttached === 'undefined' && (e.responsivelyLazyObserverAttached = !0, h.observe(e));
          }
        }; var h = new IntersectionObserver(function(a) {
          for (const b in a) {
            const c = a[b];

            c.intersectionRatio > 0 && y(c.target);
          }
        }); var f = null;
      }

      const e = function() {
        m ? (window.clearTimeout(f), f = window.setTimeout(function() {
          b = !0;
        }, 300)) : b = !0;
      }; const g = function() {
        for (let a = document.querySelectorAll('.responsively-lazy'), b = a.length, c = 0; c < b; c++) {
          for (let d = a[c].parentNode; d && d.tagName.toLowerCase() !== 'html';) {
            typeof d.responsivelyLazyScrollAttached
=== 'undefined' && (d.responsivelyLazyScrollAttached = !0, d.addEventListener('scroll', e)), d = d.parentNode;
          }
        }
      }; const k = function() {
        window.addEventListener('resize', function() {
          l = window.innerWidth; p = window.innerHeight; e();
        }); window.addEventListener('scroll', e); window.addEventListener('load', e); m && d(); g();

        typeof MutationObserver !== 'undefined' && (new MutationObserver(function() {
          q || (m && d(), g(), e());
        })).observe(document.querySelector('body'), {
          childList: !0, subtree: !0,
        });
      };

      document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', k) : k();
    };
  }

  return {
    run: z, isVisible: v,
  };
}());
